import { Avatar } from "@/components/avatar";
import { Tag, TagGroup, TagList } from "@/components/tag-group";
import { useEditRequestFormContext } from "@/features/request/edit/hooks/useEditRequestForm";
import { useGetProjectCollaborators } from "@/features/request/shared/UseGetProjectCollaborators.tsx";

import { CollaboratorsChipsSkeleton } from "./CollaboratorsSkeleton";

export function CollaboratorsView() {
  const methods = useEditRequestFormContext();
  const { data } = useGetProjectCollaborators();
  const selectedIds = methods.watch("collaboratorIds");

  if (!data) return <CollaboratorsChipsSkeleton />;

  const collaborators = data.filter((item) =>
    (selectedIds || []).includes(Number(item.id)),
  );

  if (collaborators.length === 0) {
    return (
      <span className="text-base font-normal text-text-secondary">
        No collaborators added
      </span>
    );
  }

  return (
    <TagGroup>
      <TagList items={collaborators}>
        {(item) => (
          <Tag>
            <Avatar
              alt={item.textValue}
              className="rounded-full size-3"
              src={item.profilePicture}
            />
            {item.textValue}
          </Tag>
        )}
      </TagList>
    </TagGroup>
  );
}
